































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { padHeadPanel3,logoutPanel,batchSettings,NumberKeyboard1 } from "@/components";
import { TbShop,TbGoods,TbTransferOrder } from '@/http';
import { tailFun } from "@/common/util/tail";
import selectProduct from "./components/selectProduct.vue"
import searchDia from "./components/searchDia.vue"
import { Toast } from 'vant';
@Component({
    components: {
        padHeadPanel3,selectProduct,logoutPanel,batchSettings,NumberKeyboard1,searchDia
    },
})
export default class addAllot extends Vue {
    public $refs: {
        barcode:HTMLFormElement;
    };

    tailFun = tailFun;
    /**用户信息 */
    userInfo:any={};
    /**接收门店下拉 */
    showShopnamePopover = false;
    shopOptions=[];
    receiveShopId = '';

    /**列表加载相关 */
    refreshing= false;
    loading = false;
    finished = false;
    list=[];
    total=0;
    currentPage=1

    /**查询项 */
    searchValue={
        key:'',
        sortType:1,
        sortValue:2,
        skip:0,
        count:10,
    }
    searchValue1 = {
        sjsjasc:false,
        sjsjdsc:true,
        xlasc:false,
        xldsc:false,
        kcasc:false,
        kcdsc:false
    }
    showKeyboard = false;
    isZWjp = false;
    isfouus = false;
    isNeedDot = false
    config = {
        loop : [
            {
                number : 1,
                key : 'number-1',
            },
            {
                number : 2,
                key : 'number-2',
            },
            {
                number : 3,
                key : 'number-3',
            },
            {
                number : 4,
                key : 'number-4',
            },
            {
                number : 5,
                key : 'number-5',
            },
            {
                number : 6,
                key : 'number-6',
            },
            {
                number : 7,
                key : 'number-7',
            },
            {
                number : 8,
                key : 'number-8',
            },
            {
                number : 9,
                key : 'number-9',
            },
        ]
    }
    value = null;
    maxLength = 16;

    // 选中的调拨商品
    dblist = [];
    /**调拨商品最大种类数（按 goodsId，不是规格行数/调拨数量） */
    maxDblistCount = 100;
    /**调拨明细条数上限（dblist 数组长度，不是调拨件数） */
    maxAllotNum = 500;

    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;
    tipType=1;

    isAddLoading = false;

    created() {
    }
    async mounted(){
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
        await this.getshopList();
        let savedblist = JSON.parse(localStorage.getItem("savedblist"));
        console.log('savedblist',savedblist)
        if(savedblist && savedblist.length>0) {
            this.tipTitle = "取回调拨单";
            this.tipText = `有调拨单未完成，是否取回？`;
            this.btnNums=2;
            this.confirmText = "确认";
            this.cancelText = "取消"
            this.tipType = 5;
            this.$nextTick(()=>{
                this.tipShow = true;
            })
        }
        this.getInputFocus()
        document.addEventListener('click',this.chargeInputFocus)

        
    }
    getInputFocus(){
        this.$nextTick(()=>{
            this.$refs['barcode'].select()
            document.addEventListener('keydown', this.handleScanCode)
        })
    }
    async scanInput(val){
        console.log('123```````````````',val)
        let res = await TbGoods.GetTbGoodsByBarCode({barCode:val});
        if(res.getGoodsItemsList&&res.getGoodsItemsList.length>0){
            if(this.$refs['search'].show){
                this.$refs['search'].searchValue.key = res.barCode?res.barCode:'';
            }else{
                this.searchValue.key = res.barCode?res.barCode:'';
                this.value =  res.barCode?res.barCode:'';
                this.getList();
            }
        }
    }

    chargeInputFocus(event){
        if (event.target.tagName.toLowerCase() != 'input') {
            this.$nextTick(()=>{
                this.getInputFocus()
            })
        }
    }
    beforeDestroy() {
        document.removeEventListener('keydown',this.handleScanCode) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
        document.removeEventListener('click', this.chargeInputFocus)
    }
    public scanCodes:any = ''
   /**
     * 监听扫码枪输入
     */
    async handleScanCode(event) {
        if (event.key === 'Backspace' || event.keyCode === 8) {
        // 允许退格键的默认行为
        return;
    }
        if (event.key === 'Enter' || event.keyCode == 13) {
            this.scanInput(event.target.value)
            this.scanCodes = ''
        return
        }
    }
    /**接受门店下拉选中信息 */
    get getShopname(){
        let str = ""
        if(this.receiveShopId){
            str = this.shopOptions.findIndex(v=>v.id==this.receiveShopId)>-1?this.shopOptions.find(v=>v.id==this.receiveShopId).shopName:'';
        }
        return str;
    }
    /**下拉刷新 */
    onRefresh(){
        // 清空列表数据
      this.finished = false;
       // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.list = [];
      this.searchValue.skip=0;
      this.searchValue.count=10;
      this.total = 0;
      this.currentPage = 1;
      this.loadMore();
    }
    /**触底加载 */
    async loadMore(){
        setTimeout(async() => {
            if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
            }
            let s = this.searchValue.count;
            let res = await TbGoods.GetGoodsList(Object.assign({},this.searchValue,{
                shopId:this.userInfo.shopId
            }));
            this.list = this.searchValue.skip==0? res.items.filter(v=>v.isShelves):this.list.concat(res.items.filter(v=>v.isShelves));
            this.total  = res.totalCount;
            this.currentPage++;
            this.searchValue.skip = (this.currentPage - 1) * s;
            this.loading = false;
            if (this.list.length >= this.total) {
                this.finished = true;
                console.log('list',this.list);
            }
        }, 1000);
    }
    /**获取商品列表 */
    async getList(){
        this.onRefresh();
    }
    //返回缓存
    goBacknew(){
        console.log('vakc');
        localStorage.setItem('savedblist',JSON.stringify(this.dblist));
        this.$router.go(-1);
    }
    goBackHome(){
        localStorage.setItem('savedblist',JSON.stringify(this.dblist));
        this.$router.push("/pad/mainPage/index");
    }
    /**获取接收门店下拉 */
    async getshopList(){
        let res= await TbShop.GetTbShoppListForSwitch({
            shopId:this.userInfo.shopId,
        })
        this.shopOptions = res.filter(v=>v.isUpdate==true && v.id!=this.userInfo.shopId);
        console.log('this.shopOptions',this.shopOptions);
    }
    /**选择接收门店id */
    async changeShopXL(item){
        this.receiveShopId = item.id;
        this.showShopnamePopover = false;
    }
    //顺序切换
    async changeSort(type){
        console.log('type',type);
        switch (type) {
            case 'sjsj':
                if (this.searchValue1.sjsjdsc) {
                    this.searchValue1.kcasc = false;
                    this.searchValue1.kcdsc = false;
                    this.searchValue1.xlasc = false;
                    this.searchValue1.xldsc = false;
                    this.searchValue1.sjsjdsc = false;
                    this.searchValue1.sjsjasc = true;
                    this.searchValue.sortType = 1;
                    this.searchValue.sortValue = 1;
                    await this.getList();
                } else {
                    this.searchValue1.kcasc = false;
                    this.searchValue1.kcdsc = false;
                    this.searchValue1.xlasc = false;
                    this.searchValue1.xldsc = false;
                    this.searchValue1.sjsjdsc = true;
                    this.searchValue1.sjsjasc = false;
                    this.searchValue.sortType = 1;
                    this.searchValue.sortValue = 2;
                    await this.getList();
                }
                break;
            case 'xl':
                if (this.searchValue1.xldsc) {
                    this.searchValue1.kcasc = false;
                    this.searchValue1.kcdsc = false;
                    this.searchValue1.xlasc = true;
                    this.searchValue1.xldsc = false;
                    this.searchValue1.sjsjdsc = false;
                    this.searchValue1.sjsjasc = false;
                    this.searchValue.sortType = 2;
                    this.searchValue.sortValue = 1;
                    await this.getList();
                } else {
                    this.searchValue1.kcasc = false;
                    this.searchValue1.kcdsc = false;
                    this.searchValue1.xlasc = false;
                    this.searchValue1.xldsc = true;
                    this.searchValue1.sjsjdsc = false;
                    this.searchValue1.sjsjasc = false;
                    this.searchValue.sortType = 2;
                    this.searchValue.sortValue = 2;
                    await this.getList();
                }
                break;
            case 'kc':
                if (this.searchValue1.kcdsc) {
                    this.searchValue1.kcasc = true;
                    this.searchValue1.kcdsc = false;
                    this.searchValue1.xlasc = false;
                    this.searchValue1.xldsc = false;
                    this.searchValue1.sjsjdsc = false;
                    this.searchValue1.sjsjasc = false;
                    this.searchValue.sortType = 3;
                    this.searchValue.sortValue = 1;
                    await this.getList();
                } else {
                    this.searchValue1.kcasc = false;
                    this.searchValue1.kcdsc = true;
                    this.searchValue1.xlasc = false;
                    this.searchValue1.xldsc = false;
                    this.searchValue1.sjsjdsc = false;
                    this.searchValue1.sjsjasc = false;
                    this.searchValue.sortType = 3;
                    this.searchValue.sortValue = 2;
                    await this.getList();
                }
                break;
            default:
                break;
        }
    }
    //点击展示键盘
    showJp(){
        if(this.isZWjp) return;
        this.showKeyboard = true;
        // if(this.showKeyboard) {
        //     this.isfouus = true;
        // }
    }
    showJp1(){
        this.isfouus = true;
    }
    changeJp(){
        this.isZWjp = !this.isZWjp;
        if(this.isZWjp) {
            this.showKeyboard = false;
            this.$nextTick(() => {
                $("#ipt_name").focus().select();
            });
        }else{
            this.showKeyboard = true;
        }
    }
    //隐藏数字键盘
    collaspeFun(){
        this.showKeyboard = false;
        this.isfouus = false;
    }
    del() {
		if(!this.value) return;
            let index = this.value.length;
            this.value = this.value.toString().slice(0,index-1);
            this.finishFun();
        }
	tap(number) {
		let val = this.value;
		let dotIndex = this.value?this.value.toString().indexOf('.'):-1;
		if(number=='.'&&dotIndex>-1||this.value&&this.value.toString().length==this.maxLength) return;
		this.value = this.value?this.value.toString() + number.toString():number.toString();
		if(dotIndex>-1){
			if(val.toString().slice(dotIndex+1).length>1){
				this.value = this.value.slice(0,dotIndex+3)
			}
		}else{
			this.value = this.value.slice(0,this.maxLength)
		}
		this.finishFun();
	}
	clearFun(){
        this.value = null;
        this.finishFun();
    }
    async finishFun(){
        this.searchValue.key = this.value;
        await this.getList();
    }
    //打开选择货品弹窗
    showDetail(id){
        console.log('id',id);
        // 新商品且已达上限时，不允许再打开规格选择
        if(!this.hasGoodsInDblist(id)&&this.getDblistGoodsCount()>=this.maxDblistCount){
            this.showMaxTip();
            return;
        }
        this.$refs['selPro'].showFun(id);
    }
    //选择货品完成（单选）
    chooseFun(val){
        console.log('vallll',val);
        this.mergeGoodsToDblist([{goodsItems:val}]);
    }
    chooseFun1(val){
        console.log('vallll',val);
        this.mergeGoodsToDblist(val);
    }
    /**合并商品到 dblist（按商品种类上限校验，按规格行合并） */
    mergeGoodsToDblist(list){
        let success = 0;
        let overflow = false;
        let map = {};
        this.dblist.forEach((item,index)=>{
            map[item.goodsItemsId] = index;
        });
        let goodsIdSet = new Set(this.dblist.map(v=>this.resolveGoodsId(v)).filter(Boolean));

        (list||[]).forEach((v)=>{
            let items = v.goodsItems || [];
            if(items.length==0) return;
            // 父级兜底 goodsId（多选列表商品 id / 规格上的 goodsId）
            let parentGoodsId = this.resolveGoodsId(items[0]) || items[0].goodsId || '';
            if(parentGoodsId&&!goodsIdSet.has(parentGoodsId)&&goodsIdSet.size>=this.maxDblistCount){
                overflow = true;
                return;
            }
            items.forEach(j=>{
                let gid = this.resolveGoodsId(j) || parentGoodsId;
                // 统一写回，避免后续计数丢 goodsId
                if(gid) j.goodsId = gid;
                let existIndex = map[j.goodsItemsId];
                if(existIndex!==undefined){
                    this.$set(this.dblist[existIndex],'num',Number(this.dblist[existIndex].num)+Number(j.num));
                }else{
                    if(!gid||(!goodsIdSet.has(gid)&&goodsIdSet.size>=this.maxDblistCount)){
                        overflow = true;
                        return;
                    }
                    this.dblist.push(j);
                    map[j.goodsItemsId] = this.dblist.length - 1;
                    goodsIdSet.add(gid);
                    success++;
                }
            })
        })
        if(overflow){
            this.showMaxTip();
        }
    }
    /**统一取商品种类 id，避免空 goodsId 导致计数偏少、上限被绕过 */
    resolveGoodsId(item){
        if(!item) return '';
        // 新数据必有 goodsId；历史脏数据用货号兜底计入种类上限
        return item.goodsId || item.goodsID || item.articleNo || '';
    }
    /**dblist 中已有商品种类数（按 goodsId 去重，不是调拨数量/规格行数） */
    getDblistGoodsCount(){
        let ids = this.dblist.map(v=>this.resolveGoodsId(v)).filter(Boolean);
        // target es5 未开 downlevelIteration，用 Array.from 而非展开 Set
        return Array.from(new Set(ids)).length;
    }
    hasGoodsInDblist(goodsId){
        if(!goodsId) return false;
        return this.dblist.some(v=>this.resolveGoodsId(v)==goodsId);
    }
    /**超出最大商品数提示 */
    showMaxTip(){
        this.tipTitle = "操作提醒";
        this.tipText = `最多只能选择${this.maxDblistCount}条商品`;
        this.btnNums = 1;
        this.confirmText = "确认";
        this.tipType = 6;
        this.$nextTick(()=>{
            this.tipShow = true;
        })
    }
    /**批量设数量 */
    batchSet(val){
       if(Number(val)==0) {
            Toast('数量不可为0');
            return;
       }
       this.dblist = this.dblist.map(v=>{
        return {
            ...v,
            num:Number(val)
        }
       })
    }
    finishNum2(value,index,item){
        console.log('finishNum2',value,item);
        if(Number(value)==0) {
            Toast('数量不可为0');
            return;
        }
        this.$set(this.dblist[index],'num',Number(value));
    }
    //删除单个
    delSingle(index){
        this.dblist.splice(index,1);
    }
    //清空按钮
    delAll(){
        this.tipTitle = "操作提醒";
        this.tipText = `确定清空已选择的调拨商品吗？`;
        this.btnNums=2;
        this.confirmText = "确认";
        this.cancelText = "取消"
        this.tipType = 1;
        this.$nextTick(()=>{
            this.tipShow = true;
        })
    }
    //调拨前奏
    allotJudge(){
        if(this.isAddLoading) return;
        if(this.dblist.length==0) {
            this.tipTitle = "操作提醒";
            this.tipText = `请添加需要调拨的商品`;
            this.btnNums=1;
            this.confirmText = "确认";
            this.tipType = 2;
            this.$nextTick(()=>{
                this.tipShow = true;
            })
            return;
        }
        let arr = this.dblist.filter(val=>val.num==0||val.num=='')
        if(arr.length>0){
            this.tipTitle = "操作提醒";
            this.tipText = `数量不可为0`;
            this.btnNums=1;
            this.confirmText = "确认";
            this.tipType = 2;
            this.$nextTick(()=>{
                this.tipShow = true;
            })
            return;
        }

        if(this.dblist.length > this.maxAllotNum) {
            this.tipTitle = "操作提醒";
            this.tipText = `调拨条数不能超过${this.maxAllotNum}`;
            this.btnNums=1;
            this.confirmText = "确认";
            this.tipType = 2;
            this.$nextTick(()=>{
                this.tipShow = true;
            })
            return;
        }

        if(!this.receiveShopId) {
            this.tipTitle = "操作提醒";
            this.tipText = `请选择接收门店`;
            this.btnNums=1;
            this.confirmText = "确认";
            this.cancelText = "取消"
            this.tipType = 3;
            this.$nextTick(()=>{
                this.tipShow = true;
            })
            return;
        }
        this.tipTitle = "操作提醒";
        this.tipText = `确定将已选择的商品调拨至其他门店吗？`;
        this.btnNums=2;
        this.confirmText = "确认";
        this.cancelText = "取消"
        this.tipType = 4;
        this.$nextTick(()=>{
            this.tipShow = true;
        })
    }
    //调拨成功进行时
    async postAllot(){
        if(this.isAddLoading) return;
        this.isAddLoading = true;
        Toast.loading({
            message: "调拨中...",
            forbidClick: true,
            duration: 0
        });
        try {
            let obj = {
                transferPrice:this.getTotal(),
                outShopId:this.userInfo.shopId,
                receiveShopId:this.receiveShopId,
                details:this.formateArr(),
            }
            console.log('obk',obj);
            await TbTransferOrder.PostTransferOrderV2(obj);
            Toast.clear();
            Toast('调拨成功');
            localStorage.removeItem("savedblist");
            this.$router.go(-1);
        } catch (error) {
            // 失败允许再次点击
            Toast.clear();
        } finally {
            this.isAddLoading = false;
        }
    }
    /**格式化调拨数据 */
    formateArr(){
        let arr = [];
        arr = this.dblist.map((v,index)=>{
            return{
                goodsId:v.goodsId,
                goodsItemsId:v.goodsItemsId,
                num:Number(v.num),
            }
        })
        return arr;
    }
    /**提示弹窗 */
    async tipConfirm(){
        switch (this.tipType) {
            case 1:
                this.dblist = [];
                break;
            case 4:
                if(this.isAddLoading) break;
                this.postAllot();
                break;
            case 5:
                let savedblist = JSON.parse(localStorage.getItem("savedblist"));
                this.dblist = savedblist;
                break;
            default:
                break;
        }
        this.tipShow = false;
    }
    tipCancel(){
        if(this.tipType==5) {
            localStorage.removeItem("savedblist");
        }
        this.tipShow = false;
    }
    //打开查询货品弹窗
    searchBox(){
        this.$refs['search'].showFun(this.dblist);
    }
    //计算调拨数量
    getNum(){
        let num = 0;
        let arr = this.dblist.filter((v) => Number(v.num) > 0).map((v) => v.num);
        if (arr.length > 0) {
            num = arr.reduce((n, m) => Number((Number(n) + Number(m)).toFixed(0)));
        }
        return Number(num);
    }
    //计算调拨总额
    getTotal() {
        let num = 0;
        let arr = this.dblist.filter((v) => Number(v.num) > 0).map(v=>Number(v.price)*Number(v.num));
        if (arr.length > 0) {
            num = arr.reduce((n, m) => Number(tailFun(Number(n) + Number(m), 2)));
        }
        return Number(num);
    }
    getShopnum(id){
        let num = 0;
        let arr = id?this.dblist.filter((v) => v.goodsId == id).map((v) => v.num):[];
        if (arr.length > 0) {
            num = arr.reduce((n, m) => Number((Number(n) + Number(m)).toFixed(0)));
        }
        return Number(num);
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/allot/addAllot.vue